await import('/mnt/volume-fsn1-2/domains/expertai/www/learn-front/node_modules/@umijs/bundler-webpack/client/client/client.js');
await import('/mnt/volume-fsn1-2/domains/expertai/www/learn-front/src/.umi/umi.ts');
export default 1;